import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/auth',
    name: 'auth',
    component: () => import('./views/Auth.vue'),
    children: [
      {
        path: '/login',
        name: 'login',
        text: 'Login',
        icon: 'business',
        component: () => import('./components/auth/AuthForm.vue')
      },
      {
        path: '/cadastro',
        name: 'activate',
        text: 'Ativar cadastro',
        icon: 'business',
        component: () => import('./components/auth/ActivateForm.vue')
      }
    ]
  },
  {
    path: '/',
    name: 'home',
    component: () => import('./views/LogedArea.vue'),
    children: [
      {
        path: '/planos',
        name: 'plans',
        text: 'Planos',
        icon: 'business',
        component: () => import('./components/plans/index.vue')
      },
      {
        path: '/boletos',
        name: 'bankSlipDuplicate',
        text: 'Boletos',
        icon: 'business',
        component: () => import('./components/bankSlipDuplicate/index.vue')
      },
      {
        path: '/carteirinha',
        name: 'cardDuplicate',
        text: '2ª via de carteirinha',
        icon: 'business',
        component: () => import('./components/cardDuplicate/index.vue')
      },
      {
        path: '/dadoscadastrais',
        name: 'userDataUpdate',
        text: 'Dados cadastrais',
        icon: 'business',
        component: () => import('./components/userDataUpdate/index.vue')
      },
      {
        path: '/relatorios',
        name: 'reports',
        text: 'Relatórios',
        icon: 'business',
        component: () => import('./components/reports/index.vue'),
        children: [
          {
            path: '/extratodepagamentos',
            name: 'payments',
            text: 'Extrato de pagamentos',
            icon: 'business',
            component: () => import('./components/reports/payments.vue')
          },
          {
            path: '/irpf',
            name: 'irpf',
            text: 'IRPF',
            icon: 'business',
            component: () => import('./components/reports/irpf.vue')
          }
        ]
      }]
  },
  {
    path: '',
    name: 'openedArea',
    component: () => import('./views/OpenedArea.vue'),
    children: [
      {
        path: '/2aviaboletos',
        name: 'bankSlipDuplicate2',
        text: 'Boletos',
        icon: 'business',
        component: () => import('./components/bankSlipDuplicate/index.vue')
      }]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
